import { NSTable } from 'bricks';
import PeriodCellValue from 'views/ProFormaTable/components/ProForma/ProFormaDevelopment/DevelopmentUsesTable/PeriodCellValue/PeriodCellValue';
import { IExtractedSource } from 'types/db/ExtractedProForma';
import { IFormattedCashFlowPeriod } from 'views/ProFormaTable/types';
import {
    AMOUNT_COLUMN, PERIOD_CELL_CLASS_NAME, TOTAL_LABEL, TOTAL_PERIOD_CELL_CLASS_NAME,
} from '../constants';
import {
    formatAmount, periodValues, sumPeriodValues, sumValues, toNumber,
} from '../helpers';
import PeriodHeaderCells from '../PeriodHeaderCells/PeriodHeaderCells';

export interface SourcesTableProps {
    sources: IExtractedSource[];
    periodColumns: IFormattedCashFlowPeriod[];
}

const SourcesTable = ({ sources, periodColumns }: SourcesTableProps) => {
    const grandTotal = sumValues(sources.map(source => toNumber(source.total)));
    const grandPeriodTotals = sumPeriodValues(sources.map(source => periodValues(source.periods)));

    return (
        <div className="d-flex scrollable-container pb-1">
            <NSTable className="NSTable--sticky-headers NSTable--sticky-headers--full-width NSTable--sticky-headers--two-sticky-columns">
                <thead className="NSTable__thead">
                    <tr className="NSTable__thead__tr">
                        <th className="NSTable__thead__tr__th NSTable__thead__tr__th--right-border align-middle py-1">Sources</th>
                        <th className="NSTable__thead__tr__th NSTable__thead__tr__th--right-border align-middle text-right py-1">{AMOUNT_COLUMN}</th>
                        <PeriodHeaderCells periodColumns={periodColumns} />
                    </tr>
                </thead>
                <tbody className="NSTable__tbody">
                    {sources.map((source, index) => {
                        const sourcePeriodValues = periodValues(source.periods);
                        return (
                            <tr key={`${source.name}-${index}`} className="NSTable__tbody__tr">
                                <td className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border text-dark">{source.name}</td>
                                <td className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border text-dark text-right text-nowrap pr-2">
                                    {formatAmount(toNumber(source.total))}
                                </td>
                                {periodColumns.map(column => (
                                    <PeriodCellValue
                                        key={column.value}
                                        period={column}
                                        value={formatAmount(sourcePeriodValues.get(column.period) ?? null)}
                                        cellClassName={PERIOD_CELL_CLASS_NAME}
                                    />
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot className="NSTable__tfoot font-weight-bold">
                    <tr className="NSTable__tfoot__tr">
                        <td className="NSTable__tfoot__tr__td NSTable__tfoot__tr__td--right-border text-left">{TOTAL_LABEL}</td>
                        <td className="NSTable__tfoot__tr__td NSTable__tfoot__tr__td--right-border text-right text-nowrap pr-2">
                            {formatAmount(grandTotal)}
                        </td>
                        {periodColumns.map(column => (
                            <PeriodCellValue
                                key={column.value}
                                period={column}
                                value={formatAmount(grandPeriodTotals.get(column.period) ?? null)}
                                cellClassName={TOTAL_PERIOD_CELL_CLASS_NAME}
                            />
                        ))}
                    </tr>
                </tfoot>
            </NSTable>
        </div>
    );
};

export default SourcesTable;
